import React from 'react';
import SectionHero from './sections/SectionHero';
import SectionProductGrid from './sections/SectionProductGrid';
import SectionEventList from './sections/SectionEventList';
import SectionPresentation from './sections/SectionPresentation';
import SectionAIContent from './sections/SectionAIContent';
import SectionCTA from './sections/SectionCTA';
import SectionInquiryForm from './sections/SectionInquiryForm';
import SectionTestimonial from './sections/SectionTestimonial';
import SectionFAQ from './sections/SectionFAQ';
import SectionBlog from './sections/SectionBlog';
import SectionSurvey from './sections/SectionSurvey';
import SectionCustomHTML from './sections/SectionCustomHTML';

const SECTION_COMPONENTS = {
  hero: SectionHero,
  product_grid: SectionProductGrid,
  event_list: SectionEventList,
  presentation: SectionPresentation,
  ai_content: SectionAIContent,
  cta_banner: SectionCTA,
  inquiry_form: SectionInquiryForm,
  testimonial: SectionTestimonial,
  faq: SectionFAQ,
  blog: SectionBlog,
  survey: SectionSurvey,
  custom_html: SectionCustomHTML,
};

export default function SiteSectionRenderer({ section, slug, siteInfo }) {
  const Component = SECTION_COMPONENTS[section.section_type];
  if (!Component) return null;
  return (
    <div id={`section-${section.section_type}`}>
      <Component section={section} slug={slug} siteInfo={siteInfo} />
    </div>
  );
}
